module.exports = __webpack_public_path__ + "img/20200513_145949.8ef8be71.jpg";